/* eslint-disable react/require-default-props */
import { Box, styled } from '@material-ui/core';
import { MessagingProviderSmallIcon } from '@src/model/frontendmodel';
import React from 'react';
import CustomAvatar from '../Common/CustomAvatar';

export type BadgeProvider = keyof typeof MessagingProviderSmallIcon;
type ChatContactAvatarProps = {
  name: string;
  src?: string;
  badgeProvider?: BadgeProvider;
  muted?: boolean;
};

const ChatContactAvatar: React.FC<ChatContactAvatarProps> = ({
  name,
  src,
  badgeProvider,
  muted,
}) => (
  <Box position="relative" mt={-0.5}>
    <CustomAvatar
      avatarSrc={badgeProvider?.startsWith('WHATSAPP') ? undefined : src}
      username={name}
      muted={muted}
    />
    <Box position="absolute" style={{ bottom: 0, right: 0 }}>
      {!!badgeProvider && MessagingProviderSmallIcon[badgeProvider] && (
        <BadgeProvider
          src={MessagingProviderSmallIcon[badgeProvider]}
          alt="msgProviderIcon"
        />
      )}
    </Box>
  </Box>
);

const BadgeProvider = styled('img')({
  position: 'absolute',
  bottom: -2,
  right: -3,
  width: 15,
  height: 15,
});

export default ChatContactAvatar;
